<script lang="ts">
  export let open: boolean = false;
</script>

<div class="open-close" role="presentation">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 6">
    <g stroke="currentcolor" stroke-width="0.4" stroke-linecap="round">
      <path d="M 0,3 6,3"></path>
      <path d="M 0,3 6,3" class:closed={!open}></path>
    </g>
  </svg>
</div>

<style>
  .open-close {
    display: flex;
    height: 1rem;
    width: 1rem;
  }

  path {
    transition: transform var(--transition);
    transform-origin: center;
  }

  .closed {
    transform: rotate(90deg);
  }

  :global(svg) {
    width: 100%;
    height: 100%;
  }
</style>
